<template>
  <div class="donwload-buttom" @click="handleDownload">
    <img src="@/assets/image/app-store.png" />
  </div>
</template>

<script>
import { isWeiXin } from '@engineer/utils'

export default {
  name: 'DonwloadButtom',
  data() {
    return {}
  },
  methods: {
    handleDownload() {
      if (isWeiXin()) {
        location.href = this.$store.state.user.downloadUrl
      } else {
        alert('请在浏览器中打开该页面以下载应用')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.donwload-buttom {
  width: 250px;
  height: 80px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
